import { axiosInstance } from "../core/http";

export const formationsApi = {
  getFormations: (params) =>
    axiosInstance.get("/panel/formations/", { params }),

  getFormation: (name) =>
    axiosInstance.get(`/panel/formations/${name}/`),
};
